import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface EntityBreadcrumbContextValue {
  entityLabel: string | null;
  setEntityLabel: (label: string | null) => void;
}

const EntityBreadcrumbContext = createContext<EntityBreadcrumbContextValue>({
  entityLabel: null,
  setEntityLabel: () => {},
});

export function EntityBreadcrumbProvider({ children }: { children: ReactNode }) {
  const [entityLabel, setLabel] = useState<string | null>(null);
  const setEntityLabel = useCallback((label: string | null) => setLabel(label), []);
  return (
    <EntityBreadcrumbContext.Provider value={{ entityLabel, setEntityLabel }}>
      {children}
    </EntityBreadcrumbContext.Provider>
  );
}

export function useEntityBreadcrumb() {
  return useContext(EntityBreadcrumbContext);
}
